const map = {
	"./1l.webp": 5455,
	"./1m.webp": 7516,
	"./1s.webp": 2794,
	"./2l.webp": 9588,
	"./2m.webp": 2599,
	"./2s.webp": 221,
	"./3l.webp": 8241,
	"./3m.webp": 8486,
	"./3s.webp": 8480,
	"./4l.webp": 3598,
	"./5l.webp": 1659,
	"./6l.webp": 1712
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2623;